import store, { noticeActions } from '@apply/adminStore';

export const AddNoticeButton = ({ notice }) => {
    const { dispatch } = store;

    const styles = {
        red: { color: 'darkred', fontSize: '13px' },
        blue: { color: 'black', fontSize: '13px' },
    };

    const addNotice = (event, notice) => {
        event.preventDefault();
        event.stopPropagation();

        if (!notice) {
            return;
        }

        dispatch(
            noticeActions.setAddNoticeModal({
                addNoticeModal: {
                    isOpen: true,
                    noticeTypeId: notice.noticeTypeId,
                    parentTypeId: notice.parentTypeId,
                    parentId: notice.parentId,
                },
            })
        );
    };

    return (
        <button
            className='link'
            onClick={(e) => {
                addNotice(e, notice);
            }}
            style={notice.isOverdue ? styles.red : styles.blue}
            title={notice.isOverdue ? 'Notice Missing. Click to Add (overdue)' : 'Notice Missing. Click to Add'}
        >
            {notice.title}
        </button>
    );
};
